import React from 'react';
import { Check, X, MinusCircle, ExternalLink } from 'lucide-react';

const SIG_LABELS = { relevant: 'Relevant', off_topic: 'Off-topic', skip: 'Skip' };

export default function ResultsTable({ articles, signals, onSignal }) {
  if (!articles || articles.length === 0) {
    return <div className="fs-empty">No articles found. Try adjusting the query.</div>;
  }
  return (
    <div className="responsive-scroll">
      <table className="fs-results-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Journal</th>
            <th>Date</th>
            <th>Source</th>
            <th>Relevance</th>
          </tr>
        </thead>
        <tbody>
          {articles.map((a, i) => {
            const id = a.pmid || a.doi || i;
            const sig = signals.get(String(id));
            return (
              <tr key={i} className={sig ? `fs-row--${sig}` : ''}>
                <td className="fs-col-title">
                  {a.url ? (
                    <a href={a.url} target="_blank" rel="noopener noreferrer" className="fs-article-link">
                      {a.title} <ExternalLink size={11} />
                    </a>
                  ) : a.title}
                  {a.authors && <div className="fs-authors">{a.authors}</div>}
                </td>
                <td className="fs-col-journal">{a.journal}</td>
                <td className="fs-col-date">{a.publicationDate?.substring(0, 7) || '—'}</td>
                <td className="fs-col-source">{a.sourceApi}</td>
                <td className="fs-col-signals">
                  <button
                    className={`fs-sig-btn fs-sig-btn--relevant ${sig === 'relevant' ? 'fs-sig-btn--active' : ''}`}
                    title="Relevant" onClick={() => onSignal(String(id), 'relevant')}
                    aria-label="Mark relevant"
                  ><Check size={13} /></button>
                  <button
                    className={`fs-sig-btn fs-sig-btn--offtopic ${sig === 'off_topic' ? 'fs-sig-btn--active' : ''}`}
                    title="Off-topic" onClick={() => onSignal(String(id), 'off_topic')}
                    aria-label="Mark off-topic"
                  ><X size={13} /></button>
                  <button
                    className={`fs-sig-btn fs-sig-btn--skip ${sig === 'skip' ? 'fs-sig-btn--active' : ''}`}
                    title="Skip" onClick={() => onSignal(String(id), 'skip')}
                    aria-label="Skip"
                  ><MinusCircle size={13} /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
